import type { UnifiedAuditEvent } from "@barmetvault/shared";
import {
  PageHeader,
  AuditFeed,
  ErrorState,
  PermissionDenied,
  LoadingState,
} from "../components/hub/OperationalUI";
import { useHubResource } from "./useHubResource";
export function LiveAuditFeed() {
  const result = useHubResource<UnifiedAuditEvent[]>("/hub/audit");
  return result.state === "denied" ? (
    <PermissionDenied />
  ) : result.state === "error" ? (
    <ErrorState retry={result.retry} />
  ) : result.data ? (
    <AuditFeed events={result.data} />
  ) : (
    <LoadingState />
  );
}
export default function UnifiedAuditPage() {
  return (
    <section className="hub-page">
      <PageHeader
        title="Auditoría"
        subtitle="Actividad HUMAN · AGENT · SYSTEM de tu organización. Últimos 50 eventos."
      />
      <LiveAuditFeed />
    </section>
  );
}
